// extracted by mini-css-extract-plugin
export default {"payModalWrap":"payModal_payModalWrap__q+q1e","bigTitle":"payModal_bigTitle__Th9Hr","payModalWrap_P":"payModal_payModalWrap_P__5e0dM"};